var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRazorpayIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 23,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.52229 7.36043L7.42053 11.4156L13.7268 7.33735L9.60236 22.7256L13.7911 22.7291L19.884 0",
  fill: "#3395FF"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.73483 16.2598L0 22.7291H8.5853L12.0983 9.56885L1.73483 16.2598Z",
  fill: "#072654"
})));
export default SvgRazorpayIcon;